import { type BadgeColor } from './types';

interface Props {
  color: BadgeColor;
  label?: string;
}

export default function StatusBadge({ color, label }: Props) {
  return (
    <>
      <i className={`fa fa-circle text-${color} fs-7 ${label && 'me-2'} align-middle`}></i>
      {label && <span className='fs-8 fw-bold'>{label}</span>}
    </>
  );
}
